<template>
    <div class="page-pricing">
        <div class="container">
            <div class="row">
                <div class="col-lg-12 text-center">
                    <h1>Vi synes selv, at det er fair.</h1>

                    <p>
                        OP'N er 100% gratis for alle. Vi kræver kun et fast månedsbeløb, hvis du vil opgradere
                        og bruge alle OP'N's  muligheder, da vi skal betale en tredjepart for disse funktioner.
                        Det synes vi er fair.
                    </p>
                </div>
            </div>
        </div>

        <!-- Pricing tables -->

        <pricing-tables></pricing-tables>
    </div>
</template>

<style lang="scss" scoped>
   @import '~bootstrap/scss/bootstrap.scss';

    .page-pricing {
        padding-top: 15vh;

        h1 {
            margin-bottom: 20px;

            @include media-breakpoint-down(md) {
                font-size: 30px;
            }
        }

        p {
            max-width: 50vw;
            font-weight: 200;
            font-size: 18px;
            margin: 0 auto;

            @include media-breakpoint-down(md) {
                max-width: 90vw;
            }
        }
    }
</style>

<script>
    import PricingTables from '@/components/PricingTables'

    export default {
        components: {
            PricingTables
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/Pricing.vue